import { render, staticRenderFns } from "./text_form.vue?vue&type=template&id=5df00764&scoped=true"
var script = {}
import style0 from "./text_form.vue?vue&type=style&index=0&id=5df00764&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df00764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df00764')) {
      api.createRecord('5df00764', component.options)
    } else {
      api.reload('5df00764', component.options)
    }
    module.hot.accept("./text_form.vue?vue&type=template&id=5df00764&scoped=true", function () {
      api.rerender('5df00764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/district_area_update_and_adjust/form/text_form.vue"
export default component.exports